var map = {
	"./cnr/translation.toml": [
		9548,
		548
	],
	"./de/translation.toml": [
		732,
		732
	],
	"./en/translation.toml": [
		5687,
		68
	],
	"./es-mx/translation.toml": [
		5727,
		727
	],
	"./fr/translation.toml": [
		8695,
		76
	],
	"./hi/translation.toml": [
		7156,
		156
	],
	"./it/translation.toml": [
		9226,
		226
	],
	"./nl/translation.toml": [
		8269,
		269
	],
	"./ph/translation.toml": [
		5027,
		27
	],
	"./pl/translation.toml": [
		1103,
		103
	],
	"./pt-br/translation.toml": [
		9482,
		482
	],
	"./pt-pt/translation.toml": [
		2666,
		666
	],
	"./pt/translation.toml": [
		9271,
		271
	],
	"./template/translation.toml": [
		1473
	],
	"./uwu/translation.toml": [
		1266,
		266
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 7363;
module.exports = webpackAsyncContext;